import React from 'react';
import './saveStatus.css';

// Status-driven indicator for autosaving fields. Pairs with
// useAutosave (or any other autosave logic) which feeds the current
// state into this component. The component is purely visual — no
// debounce or save logic lives here.
//
// States: 'idle' | 'saving' | 'saved' | 'error'
//
// `min-width: 90px` on the wrapper is critical: it stops the panel
// header from jitter-shifting as the status text changes length
// across states.

const Spinner = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="save-status-spinner">
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);

const Check = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const AlertCircle = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export default function SaveStatus({ status = 'idle', className = '' }) {
  const config = (() => {
    if (status === 'saving') return { icon: <Spinner />, text: 'Saving…' };
    if (status === 'saved')  return { icon: <Check />,   text: 'Saved' };
    if (status === 'error')  return { icon: <AlertCircle />, text: "Couldn't save" };
    return { icon: null, text: '' };
  })();
  return (
    <div
      role={status === 'error' ? 'alert' : 'status'}
      aria-live={status === 'error' ? 'assertive' : 'polite'}
      className={`save-status save-status--${status} ${className}`.trim()}>
      {config.icon}
      {config.text && <span>{config.text}</span>}
    </div>
  );
}
